module.exports = __webpack_public_path__ + "img/amazon.2d6d95e0.svg";